import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isBookkeepingEnabled(): boolean {
  return getFeatureToggleClient().variation('Portals.BookkeepingEnabled', false)
}
